import React, { useEffect, useState } from "react";
import {
  stopPlayingAudio,
  getDefaultLanguage,
  getUserToken,
  getUserCadre,
  getUserKb,
  getAgents,
  getUserType,
  getOnboardingFlag,
  getConsentFlag,
  getTooltip,
  handleTooltipOnboarding,
  getLanguageChangeFlag,
  setLanguageChangeFlag,
  CheckLanguageSupport,
  setAgents,
  setTooltip,
  setUserCadre,
  setUserKb,
  saveOnboardingFlag,
  saveConsentFlag,
  setUserApproach,
  isNeGDDeployment,
  isPwaInstalled,
  getDeferredPrompt,
  playAudio,
  routeAfterAuth,
} from "../../../Actions/Utils";
import {
  guideButtons,
  nextConstant,
  selectLanguageConstant,
  codeToSvgName,
} from "../../../NewConstants/IntroductionConstants";
import { useNavigate } from "react-router-dom";
import NextBtn from "../../../Shared/Components/NextBtn/NextBtn";
import ToastMessage from "../../../Shared/Components/ToastMessage/ToastMessage";
import { getLanguages } from "../../../Actions/UserActions";

const IndicLang = ({
  selectedLanguage,
  setSelectedLanguage = () => {},
  audioRef,
  setStepIndex,
  setStartTour,
}) => {
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const navigate = useNavigate();
  const LANG_ICON_PATH = "/Assets/Images/Lang/";

  useEffect(() => {
    async function fetchLanguages() {
      setLoading(true);
      if (getUserCadre() && getUserKb()) {
        const res = await getLanguages(getUserCadre(), getUserKb());
        if (res?.status === 200 && res.data?.languages) {
          setLanguages(res.data.languages);
        } else {
          setLanguages([]);
          setShowToastMessage(true);
          setToastErrorMessage("No languages found");

        }
      }else{
        const res = await getLanguages();
        if (res?.status === 200 && res.data?.languages) {
          setLanguages(res.data.languages);
        } else {
          setLanguages([]);
          setShowToastMessage(true);
          setToastErrorMessage("No languages found");
        }
      }
      setLoading(false);
    }
    fetchLanguages();
  }, []);
  
  useEffect(() => {

    if (getLanguageChangeFlag() === "true") {
      if (getAgents() && getUserType() === "Internal") {
        navigate("/kb-selection");
      } else {
        if (!getOnboardingFlag()) {
          navigate("/guide");
        } else {
          if (!getConsentFlag()) {
            navigate("/consent");
          } else {
            const tooltip = getTooltip();
            handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
            navigate("/chat");
          }
        }
      }
    }
  }, [navigate]);

  useEffect(() => {
    // Set initial selected language from getDefaultLanguage
    if (!selectedLanguage) {
      const defLang = getDefaultLanguage() || "en";
      if (defLang) setSelectedLanguage(defLang);
    }
  }, [selectedLanguage, setSelectedLanguage]);

  useEffect(() => {
    if (showSpeakerActive) {
      const filePath = `/Assets/Sounds/LanguagePage/${selectedLanguage}_language.mp3`;
      playAudio(filePath, audioRef, () => setShowSpeakerActive(false));
    } else {
      stopPlayingAudio(audioRef);
    }
  }, [showSpeakerActive, selectedLanguage, audioRef]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      stopPlayingAudio(audioRef);
      setShowSpeakerActive(false);
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [audioRef, navigate]);

  const handleSelect = (code) => {
    setSelectedLanguage(code);
  };

  const handleConfirm = () => {
    const token = getUserToken();
    if (token) {
      if (getAgents() && getUserType() === "Internal") {
        navigate("/kb-selection");
        setLanguageChangeFlag("true");
      } else {
        if (!getOnboardingFlag()) {
          navigate("/guide");
          setLanguageChangeFlag("true");
        } else {
          if (!getConsentFlag()) {
            navigate("/consent");
            setLanguageChangeFlag("true");
          } else {
            const tooltip = getTooltip();
            handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
            navigate("/chat");
            setLanguageChangeFlag("true");
          }
        }
      }
    } else if (!isPwaInstalled() && getDeferredPrompt()) {
      navigate("/install");
    } else {
      navigate(isNeGDDeployment() ? "/app-error" : "/login");
    }
  };

  return (
    <div
      style={{ backgroundImage: `url("/Assets/Images/wallpaperBg.jpg")` }}
      className="bg-[var(--primary-dark-2)] h-full w-full relative overflow-hidden bg-blend-color-burn"
    >
      <div className="relative h-full flex flex-col">
        {isNeGDDeployment() && (
          <div className="h-[3.75rem] w-full shrink-0">
          </div>
        )}
        <div className="w-full shrink-0 px-4 pt-4 pb-1 flex justify-end">
          <div
            className={`speakerDiv ${
              showSpeakerActive ? "Active" : ""
            }`}
            onClick={() => {
              setShowSpeakerActive((prev) => !prev);
            }}
          >
            {showSpeakerActive
              ? guideButtons.stop[selectedLanguage]
              : null}
            {showSpeakerActive ? (
              <div className="">
                <img
                  src={"/Assets/Images/blueSpeaker.svg"}
                  alt="active Speaker"
                />
              </div>
            ) : (
              <div className="">
                <img
                  src={"/Assets/Images/crossSpeakerIcon.svg"}
                  alt="speaker"
                />
              </div>
            )}
          </div>
        </div>
        <div className="flex-1 min-h-0 w-full overflow-y-auto flex flex-col items-center px-4">
          {/* Logo takes the leftover height (up to its natural 196px) and shrinks first on short screens */}
          <div className="mt-auto flex-1 min-h-[5rem] max-h-[12.25rem] w-full flex justify-center">
            <img className="h-full w-auto max-w-full object-contain" src={"/Assets/Images/Logo.svg"} alt="asha" />
          </div>
          <div className="shrink-0 font-bold text-white text-[1.5rem] text-center mt-3">
            {selectLanguageConstant[selectedLanguage] || "Select Language"}
          </div>
          <div className="shrink-0 mb-auto flex flex-wrap justify-center gap-x-4 gap-y-3 mt-3 pb-2">
          {loading ? (
            <div className="col-span-3 text-white">Loading...</div>
          ) : (
            languages.map((lang) => {
              const isSelected = selectedLanguage === lang.value;
              // Use English name from code for SVG file
              const engName = codeToSvgName[lang.value];
              const color = isNeGDDeployment() ? "Red" : "Blue";
              const svgFile = `${LANG_ICON_PATH}${engName} - ${
                isSelected ? color : "White"
              }.svg`;
              return (
                <div key={lang.value} className="flex flex-col items-center justify-center">
                  <div
                    key={lang.label}
                    className={`flex flex-col items-center justify-center rounded-full border-2 cursor-pointer ${
                      isSelected ? `bg-white shadow-lg` : ""
                    } p-2 w-[clamp(4rem,14vh,4.91rem)] h-[clamp(4rem,14vh,4.91rem)]`}
                    style={{ borderColor: isSelected ? "var(--primary-dark-2)" : "var(--light-neutral-2)" }}
                    onClick={() => handleSelect(lang.value)}
                  >
                    <img
                      className="max-w-full max-h-full"
                      src={svgFile}
                      alt={lang.label}
                    />
                  </div>
                  <span className={`text-base ${selectedLanguage === lang.value ? "font-bold" : ""} text-white`}>
                    {lang.label}
                  </span>
                </div>
              );
            })
          )}
          </div>
        </div>
        <div className="w-full shrink-0 flex justify-center pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
        <div className="min-w-[8.75rem] min-h-[2.875rem]">
            {selectedLanguage && <NextBtn
              value={nextConstant[selectedLanguage]}
              icon={isNeGDDeployment() ? "/Assets/Images/nextRedIcon.svg" : "/Assets/Images/nextBlueIcon.svg"}
              bgColor={"var(--neutral-white)"}
              color={"var(--primary-dark)"}
              nextClick={handleConfirm}
              disabled={!selectedLanguage}
              textCenter={true}
              padx={12}
              pady={8}
            />}
        </div>
        </div>
      </div>
      {showToastMessage && <ToastMessage message={toastErrorMessage} direction="bottom" close={() => setShowToastMessage(false)} />}
    </div>
  );
};

export default IndicLang;
